module.exports = __webpack_public_path__ + "static/media/usa_1.5d24d4a2.jpg";